"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_STAGES = exports.ALL_AWS_REGIONS = exports.ALL_BRANDS = exports.RTL_LANGUAGES = void 0;
const basic_types_1 = require("../common/basic-types");
exports.RTL_LANGUAGES = ['ar'];
exports.ALL_BRANDS = Object.values(basic_types_1.Brand);
exports.ALL_AWS_REGIONS = Object.values(basic_types_1.AwsRegion);
exports.ALL_STAGES = ['none', 'dev', 'staging', 'qa', 'prod'];
